import {
	addAuditsItem,
	deleteAuditsItem,
	updateAuditsItem,
} from "../../services/api-server/audits";
import {
	addIncidentReportItem,
	deleteIncidentReportItem,
	updateIncidentReportItem,
} from "../../services/api-server/incident_report";
import {
	addLessonLearnedItem,
	deleteLessonLearnedItem,
	updateLessonLearnedItem,
} from "../../services/api-server/lesson_learned";
import {
	addMoCItem,
	deleteMoCItem,
	updateMoCItem,
} from "../../services/api-server/moc";
import {
	addNonConformanceItem,
	deleteNonConformanceItem,
	updateNonConformanceItem,
} from "../../services/api-server/non_conformance";
import {
	addOFIItem,
	deleteOFIItem,
	updateOFIItem,
} from "../../services/api-server/ofi";

/**
 * Normalized interface every report type's CRUD handlers must satisfy.
 * The individual API functions may accept additional optional parameters
 * (e.g. options, extraData) — those are fine as long as they have defaults.
 */
export interface ReportCrud {
	create: (data: any, user: any, tenantKey: string) => Promise<any>;
	update: (
		id: string,
		data: any,
		user: any,
		tenantKey: string,
		options?: any
	) => Promise<any>;
	delete: (id: string, tenantKey: string) => Promise<any>;
}

/**
 * `satisfies` checks every entry against ReportCrud at definition time
 * while keeping the map's own inferred type (so TS catches mismatches
 * close to the source, not at the call site).
 */
const CRUD_MAP = {
	lesson_learned: {
		create: addLessonLearnedItem,
		update: updateLessonLearnedItem,
		delete: deleteLessonLearnedItem,
	},
	incident_report: {
		create: addIncidentReportItem,
		update: updateIncidentReportItem,
		delete: deleteIncidentReportItem,
	},
	audit: {
		create: addAuditsItem,
		update: updateAuditsItem,
		delete: deleteAuditsItem,
	},
	moc: {
		create: addMoCItem,
		update: updateMoCItem,
		delete: deleteMoCItem,
	},
	ofi: {
		create: addOFIItem,
		update: updateOFIItem,
		delete: deleteOFIItem,
	},
	non_conformance: {
		create: addNonConformanceItem,
		update: updateNonConformanceItem,
		delete: deleteNonConformanceItem,
	},
} satisfies Record<string, ReportCrud>;

export type ReportCrudKey = keyof typeof CRUD_MAP;

export function getReportCrud(type: ReportCrudKey): ReportCrud {
	return CRUD_MAP[type];
}
